import User from './currentUser';
import { awsEndpoint } from './url';
import cookie from './cookie';
import validateJWT from './validateJWT';
import refetchTokens from './refetchTokens';
import handleLogout from './handleLogout';

const user = new User();

function fetchRetry(url, options, n) {
  return fetch(url, options).catch(error => {
    if (n === 1) throw error;
    return fetchRetry(url, options, n - 1);
  });
}

// All network request should happen from here. This allows
// us to configure network request from single source.
export default async function request(endpoint, fetchOptions = {}, extraOptions = {}) {
  // Set request url
  let urlString = endpoint;
  if (!endpoint.startsWith('http')) {
    const baseURL = awsEndpoint;
    const slashedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    urlString = `${baseURL}${slashedEndpoint}`;
  }
  const backendURL = new URL(urlString);

  // Set request headers
  const headers = fetchOptions.headers || {};

  if (user.isMasqueraded()) {
    headers.masquerade = JSON.stringify({ _id: user.id() });
    headers.user = JSON.stringify({ _id: user.id() });
  }

  if (!extraOptions.dontSendAuthHeader) {
    let lyearnToken = cookie.get('lyearn_token');
    const isValid = validateJWT(lyearnToken);
    if (!isValid) {
      await refetchTokens();
    }
    lyearnToken = cookie.get('lyearn_token');
    headers.lyearn_token = lyearnToken;
  }

  // Set query parameters
  const queryParams = extraOptions.queryParams || {};
  if (!extraOptions.dontAppendApiEndpointQS) {
    queryParams.apiEndpoint = 'oldbackendapi';
  }
  Object.keys(queryParams).forEach(key => backendURL.searchParams.append(key, queryParams[key]));

  // Set request timeout
  let signal = null;
  const timeout = extraOptions.timeout;
  if (timeout) {
    const controller = new AbortController();
    signal = controller.signal;

    setTimeout(controller.abort, timeout);
  }

  const retryCount = extraOptions.retryCount || 0;

  if (retryCount > 0) {
    const tryCount = retryCount + 1; // total number of `fetch`s
    return fetchRetry(
      backendURL,
      {
        signal,
        ...fetchOptions,
        headers
      },
      tryCount
    );
  }

  const response = await fetch(backendURL, {
    signal,
    ...fetchOptions,
    headers
  });
  if (response.status === 403 && !extraOptions.doNotLogoutOn403) {
    console.log(
      'lyearn_token is',
      cookie.get('lyearn_token'),
      'sendAuthHeaderFlag is',
      extraOptions.dontSendAuthHeader,
      'currentTime is',
      Date.now()
    );
    handleLogout('force_logout');
    throw new Error('FORCE_LOGOUT');
  }
  if (response.status === 401 && !extraOptions.doNotLogoutOn401) {
    console.log(
      'lyearn_token is',
      cookie.get('lyearn_token'),
      'sendAuthHeaderFlag is',
      extraOptions.dontSendAuthHeader,
      'currentTime is',
      Date.now()
    );
    handleLogout('token_invalid');
    throw new Error('TOKEN_INVALID');
  }
  return response;
}
